import React, { Component } from "react";
import { Form, Row, Col } from "react-bootstrap";

class CustomDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: "",
      endDate: "",
      selectedRange: "Today"
    };
  }
  componentDidMount() {
    this.updateDates(this.state.selectedRange);
  }

  handleRangeChange = (e) => {
    const range = e.target.value;
    this.setState({ selectedRange: range }, () => this.updateDates(range));
  };

  formatDateTime = (date, time) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day} ${time}`;
  };

  updateDates = (range) => {
    let startDate = "";
    let endDate = "";
    const currentDate = new Date();
    const today = new Date(currentDate);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const startTime = "00:00:00";
    const endTime = "23:59:59";

    switch (range) {
      case "Today":
        startDate = this.formatDateTime(today, startTime);
        endDate = this.formatDateTime(today, endTime);
        break;
      case "Tomorrow":
        startDate = this.formatDateTime(tomorrow, startTime);
        endDate = this.formatDateTime(tomorrow, endTime);
        break;
      case "Yesterday":
        startDate = this.formatDateTime(yesterday, startTime);
        endDate = this.formatDateTime(yesterday, endTime);
        break;
      case "This Week":
        startDate = this.formatDateTime(new Date(today.setDate(today.getDate() - today.getDay())), startTime);
        endDate = this.formatDateTime(new Date(today.setDate(today.getDate() + 6)), endTime);
        break;
      case "Last Week":
        const lastWeekStart = new Date(today.setDate(today.getDate() - today.getDay() - 7));
        startDate = this.formatDateTime(lastWeekStart, startTime);
        endDate = this.formatDateTime(new Date(lastWeekStart.setDate(lastWeekStart.getDate() + 6)), endTime);
        break;
      case "Next Week":
        const nextWeekStart = new Date(today.setDate(today.getDate() - today.getDay() + 7));
        startDate = this.formatDateTime(nextWeekStart, startTime);
        endDate = this.formatDateTime(new Date(nextWeekStart.setDate(nextWeekStart.getDate() + 6)), endTime);
        break;
      case "This Month":
        startDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1), startTime);
        endDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0), endTime);
        break;
      case "Last Month":
        startDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1), startTime);
        endDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth(), 0), endTime);
        break;
      case "Next Month":
        startDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1), startTime);
        endDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0), endTime);
        break;
      case "Last 90 Days":
        startDate = this.formatDateTime(new Date(today.setDate(today.getDate() - 90)), startTime);
        endDate = this.formatDateTime(new Date(), endTime);
        break;
      case "Next 7 Days":
        startDate = this.formatDateTime(new Date(), startTime);
        endDate = this.formatDateTime(new Date(today.setDate(today.getDate() + 7)), endTime);
        break;
      case "Last 7 Days":
        startDate = this.formatDateTime(new Date(today.setDate(today.getDate() - 7)), startTime);
        endDate = this.formatDateTime(new Date(), endTime);
        break;
      case "Next 15 Days":
        startDate = this.formatDateTime(new Date(), startTime);
        endDate = this.formatDateTime(new Date(today.setDate(today.getDate() + 15)), endTime);
        break;
      case "Last 15 Days":
        startDate = this.formatDateTime(new Date(today.setDate(today.getDate() - 15)), startTime);
        endDate = this.formatDateTime(new Date(), endTime);
        break;
      case "Yearly This Day":
        startDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()), startTime);
        endDate = startDate;
        break;
      case "Yearly This Month":
        startDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1), startTime);
        endDate = this.formatDateTime(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0), endTime);
        break;
      case "This Year":
        startDate = this.formatDateTime(new Date(currentDate.getFullYear(), 0, 1), startTime);
        endDate = this.formatDateTime(new Date(currentDate.getFullYear(), 11, 31), endTime);
        break;
      case "Last Year":
        startDate = this.formatDateTime(new Date(currentDate.getFullYear() - 1, 0, 1), startTime);
        endDate = this.formatDateTime(new Date(currentDate.getFullYear() - 1, 11, 31), endTime);
        break;
      case "Next Year":
        startDate = this.formatDateTime(new Date(currentDate.getFullYear() + 1, 0, 1), startTime);
        endDate = this.formatDateTime(new Date(currentDate.getFullYear() + 1, 11, 31), endTime);
        break;
      case "Custom Period <>":
      default:
        startDate = "";
        endDate = "";
        break;
    }

    this.setState({ startDate, endDate });
    this.props.onDateChange(`${startDate}~${endDate}`);
  };

  handleDateChange = (e, type) => {
    this.setState({ [type]: e.target.value }, () => {
      this.props.onDateChange(this.state.startDate, this.state.endDate);
    });
  };

  render() {
    const { startDate, endDate, selectedRange } = this.state;
    const dateRanges = [
      "Today",
      "Yesterday",
      "This Week",
      "This Month",
      "Last Month",
      "Last 90 Days",
      "Last 7 Days",
      "Last 15 Days",
      "This Year",
      "Last Year",
      "Yearly This Day",
      "Yearly This Month",
      "Custom Period <>"
    ];

    return (
      <Form className="p-0 ">
        <Row className="d-flex align-items-end">
          {/* Date range select */}
          <Col md={selectedRange === 'Custom Period <>' || this.props.type ? 4 : 12} className="mb-0">
            <Form.Group controlId="dateRangeSelect">
              {this.props.label && (
                <Form.Label style={{ fontWeight: '600', color: '#495057', marginBottom: '0.5rem' }}>
                  Date Range
                </Form.Label>
              )}
              <Form.Control
                as="select"
                value={selectedRange}
                onChange={this.handleRangeChange}
                style={{
                  height: '44px',
                  borderColor: '#ced4da'
                }}
              >
                {dateRanges.map((range, index) => (
                  <option key={index} value={range}>
                    {range}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>

          {/* Custom date fields */}
          {(selectedRange === 'Custom Period <>' || this.props.type) && (
            <>
              <Col md={4} className="mb-0">
                <Form.Group controlId="startDate">
                  {this.props.label && (
                    <Form.Label style={{ fontWeight: '600', color: '#495057', marginBottom: '0.5rem' }}>
                      Start Date
                    </Form.Label>
                  )}
                  <Form.Control
                    type="date"
                    value={startDate.slice(0, 10)}
                    onChange={(e) => this.handleDateChange(e, 'startDate')}
                    placeholder="Start Date"
                    required
                    style={{
                      height: '44px',
                      borderColor: '#ced4da'
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md={4} className="mb-0">
                <Form.Group controlId="endDate">
                  {this.props.label && (
                    <Form.Label style={{ fontWeight: '600', color: '#495057', marginBottom: '0.5rem' }}>
                      End Date
                    </Form.Label>
                  )}
                  <Form.Control
                    type="date"
                    value={endDate.slice(0, 10)}
                    onChange={(e) => this.handleDateChange(e, 'endDate')}
                    placeholder="End Date"
                    required
                    style={{
                      height: '44px',
                      borderColor: '#ced4da'
                    }}
                  />
                </Form.Group>
              </Col>
            </>
          )}
        </Row>
      </Form>

    );
  }
}

export default CustomDatePicker;

